import { loadStripe, Stripe, StripeError } from '@stripe/stripe-js';

export const getStripePublishableKey = (): string | undefined => {
    const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    console.log('key', key);
    return key && key.trim().length > 0 ? key.trim() : undefined;
};

const stripeErrorTypesWithMessage = new Set<StripeError['type']>([
    'card_error',
    'validation_error',
    'api_connection_error',
    'api_error',
    'authentication_error',
    'invalid_request_error',
    'rate_limit_error',
]);

export const shouldShowStripeErrorMessage = (error: StripeError): boolean => {
    return stripeErrorTypesWithMessage.has(error.type);
};

const cache = new Map<string, Promise<Stripe | null>>();

const checkoutLocales = ['da', 'de', 'en', 'es', 'fr', 'it', 'nl', 'sv'] as const;

type CheckoutLocale = typeof checkoutLocales[number] | 'auto';

const getStripeLocale = (language?: string | null): CheckoutLocale => {
    const normalizedLanguage = language?.trim().replace('_', '-');
    if (!normalizedLanguage) return 'auto';
    const exactLocale = checkoutLocales.find((locale) => locale.toLowerCase() === normalizedLanguage.toLowerCase());
    if (exactLocale) return exactLocale;
    const baseLanguage = normalizedLanguage.split('-')[0].toLowerCase();
    return checkoutLocales.find((locale) => locale === baseLanguage) || 'auto';
};

export const getStripe = (stripeAccountId?: string, language?: string | null): Promise<Stripe | null> => {
    const key = getStripePublishableKey();
    if (!key) return Promise.resolve(null);

    const locale = getStripeLocale(language);
    const cacheKey = [key, stripeAccountId, locale].filter(Boolean).join('|');
    if (!cache.has(cacheKey)) {
        cache.set(cacheKey, loadStripe(key, { stripeAccount: stripeAccountId, locale }));
    }
    return cache.get(cacheKey)!;
};
